import { JSONValidation, } from "../features/validation";
import { MODES } from "../constants";
import { parseYAMLDocumentState } from "../parsers/yaml-parser";
/**
 * Instantiates a JSONValidation instance with the YAML mode
 * @group Codemirror Extensions
 */
export function yamlSchemaLinter(options) {
    const validation = new JSONValidation(Object.assign({ jsonParser: parseYAMLDocumentState, mode: MODES.YAML }, options));
    return (view) => {
        return validation.doValidation(view);
    };
}
